var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.064 25.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21187",
    "data-name": "Group 21187",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21186",
    "data-name": "Group 21186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21185",
    "data-name": "Group 21185",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36850",
    "data-name": "Path 36850",
    d: "M14.986,54.852a6.536,6.536,0,1,0-6.444,0A11,11,0,0,0,0,65.243v1.605a.654.654,0,1,0,1.307,0V65.243C1.307,60,6,55.737,11.764,55.737S22.221,60,22.221,65.243v1.605a.654.654,0,1,0,1.307,0V65.243A11,11,0,0,0,14.986,54.852ZM6.536,49.2a5.228,5.228,0,1,1,5.228,5.228A5.234,5.234,0,0,1,6.536,49.2Z",
    transform: "translate(0 -42.666)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36851",
    "data-name": "Path 36851",
    d: "M334.194,94.923a5.223,5.223,0,0,0-2.873-9.589.654.654,0,0,0,0,1.307,3.921,3.921,0,1,1,0,7.843.654.654,0,1,0,0,1.307c4.325,0,7.843,3.251,7.843,7.248v1.248a.654.654,0,0,0,1.307,0v-1.248A8.639,8.639,0,0,0,334.194,94.923Z",
    transform: "translate(-310.407 -82.72)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.02dcafb1fd054d72b2ad7c19d076917e.svg";
export { ForwardRef as ReactComponent };